// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1zG7K","ranges":"BmiRanges_ranges__3Yv32"};